import React from 'react';

const ArticlesHeroSection = () => {
  return (
    <section aria-labelledby="articles-title" className="site-bg-hero text-center py-16 px-6">
      <h1
        id="articles-title"
        className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
      >
        Artigos
      </h1>
      <p className="mt-6 text-lg leading-8 text-gray-600">
        Lista completa de anotacoes, rascunhos e aprendizados recentes.
      </p>
    </section>
  );
};

export default ArticlesHeroSection;
